module.exports = __webpack_public_path__ + "static/img/7.282918a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/sp/7.png
// module id = HVcv
// module chunks = 0